import { useSelector } from "react-redux";
import { RootState } from "State/store";

export const useCartList = () =>
  useSelector((state: RootState) => state.cart.cartList);
